<template>
    <div :class="{'hidden':hidden}" class="pagination-container">
        <el-pagination
            :background="background"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :layout="layout"
            :page-sizes="pageSizes"
            :total="total"
            v-bind="$attrs"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div>
    <!-- :layout="layout" -->
</template>

<script>
import { scrollTo } from '@/utils/scrollTo'

export default {
    name: 'Pagination',
    props: {
        total: {
            required: true,
            type: Number
        },
        page: {
            type: Number,
            default: 1
        },
        limit: {
            type: Number,
            default: 20
        },
        pageSizes: {
            type: Array,
            default() {
                return [10, 20, 30, 50]
            }
        },
        layout: {
            type: String,
            default: 'prev, pager, next, jumper'
        },
        background: {
            type: Boolean,
            default: true
        },
        autoScroll: {
            type: Boolean,
            default: true
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentPage: {
            get() {
                return this.page
            },
            set(val) {
                this.$emit('update:page', val)
            }
        },
        pageSize: {
            get() {
                return this.limit
            },
            set(val) {
                this.$emit('update:limit', val)
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('pagination', { page: this.currentPage, limit: val })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }
        },
        handleCurrentChange(val) {
            this.$emit('pagination', { page: val, limit: this.pageSize })
            if (this.autoScroll) {
                scrollTo(0, 800)
            }
        }
    }
}
</script>

<style scoped>
.pagination-container {
    background: #fff;
    padding: 32px 16px;
    text-align: center;
}
.pagination-container.hidden {
    display: none;
}

.pagination-container >>> .el-pager li{min-width: 25px;height: 25px;border:1px solid #cccccc;border-radius:0;background: none;padding: 0;line-height: 23px;font-weight: 400;color: #000;}
.pagination-container >>> .el-pager li:not(.disabled):hover{color: #000;}
.pagination-container >>> .el-pager li:not(.disabled).active{background: none;color: #b92f20;border-color: #b92f20;}

.pagination-container >>> .el-pagination button{height: 25px;border:1px solid #cccccc;border-radius:0;background: none;padding: 0;line-height: 23px;font-weight: 400;color: #000;}
.pagination-container >>> .el-input__inner{height: 25px !important;border:1px solid #cccccc;border-radius:0;font-size: 14px;width: auto;}
.pagination-container >>> .el-input{width: auto !important;}
.pagination-container >>> .el-pagination__jump{line-height: 0;font-size: 12px;margin-right: 30px;}

</style>
